import React from 'react';
import { inject, observer } from 'mobx-react';
import { Modal } from 'antd';
import { WeaLocaleProvider } from 'ecCom';

import { WeaThemeCenter } from 'weaPortalPublic';

const getLabel = WeaLocaleProvider.getLabel;

@inject('portalThemeStore')
@observer
class E8LeftMenuBottom extends React.Component {
  render() {
    const { portalThemeStore } = this.props;
    const { accountMoreMenu = [] } = portalThemeStore;

    return (
      <div className="e8left-lmb">
        <WeaThemeCenter ecId={`${(this && this.props && this.props.ecId) || ''}_WeaThemeCenter@z3a5cq`} ref="WeaThemeCenter" />
        {accountMoreMenu.map((item, index) => {
          if (item.sType == 'custom') {
            return (
              <div className="e8left-lmb-item">
                <div key={index} className="e8left-lmb-personal" onClick={() => this.onOpen(item)} />
              </div>
            );
          } else if (item.sType == 'password') {
            return (
              <div className="e8left-lmb-item">
                <div key={index} className="e8left-lmb-password" onClick={() => this.onOpen(item)} />
              </div>
            );
          } else if (item.sType == 'theme') {
            return (
              <div className="e8left-lmb-item">
                <div key={index} className="e8left-lmb-skin" onClick={this.onShowThemeCenter} />
              </div>
            );
          }
        })}
      </div>
    );
  }

  onOpen = (obj) => {
    const { portalThemeStore } = this.props;
    portalThemeStore.onLoadMain(obj);
  };

  onShowThemeCenter = () => {
    const { portalThemeStore } = this.props;
    const { themeInfo = {} } = portalThemeStore;

    if (themeInfo.themeAppoint) {
      Modal.confirm({
        title: getLabel(15172, '系统提示'),
        content: getLabel(126325, '分部已指定主题模板，不能修改!'),
      });
    } else {
      this.refs.WeaThemeCenter.onShow();
    }
  };
}

export default E8LeftMenuBottom;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology8/E8LeftMenuBottom.js